import { TStoreState } from 'redux/types';
import { TPaymentsStore } from './types';

// ==========================================:
const getPaymentsState = (state: TStoreState): TPaymentsStore => state.payments;

export const getPayableInvoices = (state: TStoreState) => getPaymentsState(state).payable;
export const getPayableInvoicesLoading = (state: TStoreState) =>
	getPaymentsState(state).payableLoading;

export const getPaymentQuote = (state: TStoreState) => getPaymentsState(state).quote;
export const getPaymentQuoteLoading = (state: TStoreState) => getPaymentsState(state).quoteLoading;
export const getPaymentQuoteError = (state: TStoreState) => getPaymentsState(state).quoteError;

export const getTryToPayLoading = (state: TStoreState) => getPaymentsState(state).tryToPayLoading;
export const getTryToPayResult = (state: TStoreState) => getPaymentsState(state).tryToPayResult;
export const getTryToPayError = (state: TStoreState) => getPaymentsState(state).tryToPayError;
export const getQuoteChanged = (state: TStoreState) => getPaymentsState(state).quoteChanged;
